import { StepProps, useAutoNavigate } from '@betterment/js-runtime';
import { SuccessFullScreen } from '@betterment/samba-react';

export const SuccessStep: React.FC<StepProps> = ({ flowState }) => {
  const navigate = useAutoNavigate();

  return <SuccessFullScreen message="Generating report" onCompletion={() => void navigate(flowState.returnToPath)} />;
};
